module.exports = __webpack_public_path__ + "static/media/report.87f5d7b4.JPG";